import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0h2v0.5h-2zM1.5,0h0.5v0.5h-0.5z' },
    {
      paint: 'trunk',
      d: 'M-1.5,-6.5h0.5v0.5h-0.5zM-4,-6h1v0.5h-1zM-2.5,-6h1.5v0.5h-1.5zM-4,-5.5h2.5v0.5h-2.5zM-3,-5h1.5v0.5h-1.5zM1.5,-1.5h0.5v1h-0.5zM-0.5,-1h0.5v1h-0.5zM1.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'deer',
      d: 'M-3,-4.5h1.5v0.5h-1.5zM-3.5,-4h2v0.5h-2zM-3.5,-3.5h3.5v0.5h-3.5zM0.5,-3.5h0.5v0.5h-0.5zM-2,-3h1v0.5h-1zM1,-3h2v0.5h-2zM-2,-2.5h5v0.5h-5zM-1.5,-2h3.5v0.5h-3.5zM-1.5,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v1h-1zM1,-1h0.5v1.5h-0.5zM-1.5,0h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M0,-3.5h0.5v0.5h-0.5zM-1,-3h2v0.5h-2z' },
    { paint: 'mushroom', d: 'M0,-1.5h1.5v0.5h-1.5z' },
  ],
  pixels: 82,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0h2v0.5h-2zM1.5,0h0.5v0.5h-0.5z' },
    {
      paint: 'trunk',
      d: 'M-3.5,-3.5h0.5v0.5h-0.5zM-2.5,-3.5h0.5v0.5h-0.5zM-3,-3h1v0.5h-1zM-4,-2.5h1.5v0.5h-1.5zM-3.5,-2h1v0.5h-1zM-3.5,-1.5h0.5v0.5h-0.5zM1.5,-1.5h0.5v1h-0.5zM-0.5,-1h0.5v1h-0.5zM1.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'deer',
      d: 'M-1,-3.5h1v0.5h-1zM0.5,-3.5h0.5v0.5h-0.5zM-2,-3h1v0.5h-1zM1,-3h2v0.5h-2zM-2.5,-2.5h5.5v0.5h-5.5zM-2.5,-2h4.5v0.5h-4.5zM-3,-1.5h3v0.5h-3zM-3.5,-1h1.5v0.5h-1.5zM-1.5,-1h1v1h-1zM1,-1h0.5v1.5h-0.5zM-3.5,-0.5h1v0.5h-1zM-1.5,0h0.5v0.5h-0.5z',
    },
    { paint: 'fence', d: 'M0,-3.5h0.5v0.5h-0.5zM-1,-3h2v0.5h-2z' },
    { paint: 'mushroom', d: 'M0,-1.5h1.5v0.5h-1.5z' },
  ],
  pixels: 77,
};
const variant2: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-1,0h2v0.5h-2z' },
    {
      paint: 'trunk',
      d: 'M-1.5,-6.5h0.5v0.5h-0.5zM-4,-6h1v0.5h-1zM-2.5,-6h1.5v0.5h-1.5zM-4,-5.5h2.5v0.5h-2.5zM-3,-5h1.5v0.5h-1.5zM1.5,-1.5h0.5v1h-0.5zM-0.5,-1h0.5v1h-0.5zM1.5,-0.5h1v0.5h-1z',
    },
    {
      paint: 'deer',
      d: 'M-3,-4.5h1.5v0.5h-1.5zM-3.5,-4h2v0.5h-2zM-3.5,-3.5h3.5v0.5h-3.5zM0.5,-3.5h0.5v0.5h-0.5zM-2,-3h1v0.5h-1zM1,-3h2v0.5h-2zM-2,-2.5h5v0.5h-5zM-1.5,-2h3.5v0.5h-3.5zM-1.5,-1.5h1.5v0.5h-1.5zM-1.5,-1h1v0.5h-1zM0.5,-1h1v1h-1zM-2,-0.5h1.5v0.5h-1.5zM-2,0h1v0.5h-1zM1,0h1v0.5h-1z',
    },
    { paint: 'fence', d: 'M0,-3.5h0.5v0.5h-0.5zM-1,-3h2v0.5h-2z' },
    { paint: 'mushroom', d: 'M0,-1.5h1.5v0.5h-1.5z' },
  ],
  pixels: 86,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
